import $ from "jquery";
export const smoothScroll = {
    init: function () {
        $('a[href*="#"]')
            .not('[href="#"]')
            .not('[href*="tabs"]')
            .not('[href="#0"]')
            .not('[role="presentation"]')
            .not(".js-scroll-ignore")
            .click(function (event) {
            if (location.pathname.replace(/^\//, "") ===
                this.pathname.replace(/^\//, "") &&
                location.hostname === this.hostname) {
                let target = $(this.hash);
                target = target.length
                    ? target
                    : $("[name=" + this.hash.slice(1) + "]");
                let headerOffset = 0;
                if ($("#header").css("position") === "sticky") {
                    headerOffset = $("#header").height();
                }
                const $stickyNav = $("#js-sticky-nav");
                const $enhancedStickyNav = $("#js-enhanced-sticky-nav");
                const $activeNav = $enhancedStickyNav.length ? $enhancedStickyNav : $stickyNav;
                if ($activeNav.length) {
                    headerOffset += $activeNav.outerHeight(true);
                }
                const $helloBar = $(".c-hello-bar");
                if ($helloBar.length && $helloBar.is(":visible")) {
                    headerOffset += $helloBar.outerHeight(true);
                }
                if (target.length) {
                    history.replaceState(null, null, this.hash);
                    $("html, body").animate({
                        scrollTop: target.offset().top - headerOffset - 20,
                    }, 1000, function () {
                        const $target = $(target).children().first();
                        $target.focus();
                        if (!$target.is(":focus")) {
                            $target.attr("tabindex", "-1");
                            $target.focus();
                        }
                        else {
                            event.preventDefault();
                        }
                    });
                }
            }
        });
    },
};
